import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { ThemeProvider } from "./context/ThemeContext";

export default function App() {
  return (
    <ThemeProvider>
      <main className="text-gray-400 body-font">
        <Router>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
            }}
          >
            <div style={{ flex: 1 }}>
              <Routes>
                <Route path="/*" element={<Home />} />
              </Routes>
            </div>
          </div>
        </Router>
      </main>
    </ThemeProvider>
  );
}
